import {
  processingSessionIdFormat,
  processingSessionItemIdFormat,
} from "@redotech/redo-return-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const ProcessingReceivingTarget = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("item"),
    sessionId: processingSessionIdFormat.schema,
  }),
  z.object({
    type: z.literal("return_item"),
    sessionItemId: processingSessionItemIdFormat.schema,
  }),
]);
export type ProcessingReceivingTarget = z.infer<
  typeof ProcessingReceivingTarget
>;

export const ProcessingReceivingSource = z.object({
  bin: z
    .object({ id: storageLocationIdFormat.schema, name: z.string() })
    .nullable(),
  locked: z.boolean(),
});
export type ProcessingReceivingSource = z.infer<
  typeof ProcessingReceivingSource
>;
